module.exports = __webpack_public_path__ + "img/logo-sm.e9fac713.png";